module.exports = __webpack_public_path__ + "img/but_login_confirm.b471bf3c.png";